import React, { useEffect, useState } from 'react';

import { AllowedGuard } from 'components/Tvendo/Common/UserAction';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import { Add, Assignment, PictureAsPdf, Restore, Visibility } from '@material-ui/icons';
import Card from 'components/Card/Card';
import CardIcon from 'components/Card/CardIcon';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import { WithApp } from 'contexts/appContext';
import { Box, Tooltip } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { wsFindBy, wsUrl } from 'services/WService';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import ButtonDelete from 'hooks/ButtonDelete';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import Badge from 'components/Badge/Badge';
import { wsUpdate } from 'services/WService';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 260 },
  { Header: 'Fec. Creación', accessor: 'created_at', width: 90 },
  { Header: 'Fec. Act.', accessor: 'updated_at', width: 90 },
  { Header: 'Fec. Aprobación', accessor: 'approved_at', width: 90 },
  { Header: 'Cód. Cliente', accessor: 'CardCode', width: 120 },
  { Header: 'Nom. Cliente', accessor: 'CardName', width: 120 },
  { Header: 'Zona', accessor: 'zone' },
  { Header: 'Almacén', accessor: 'WhsName', width: 100 },
  { Header: 'Marca', accessor: 'mark' },
  { Header: 'Categoria', accessor: 'category', width: 110 },
  { Header: 'Linea', accessor: 'line' },
  { Header: 'Estado', accessor: 'state' },
  { Header: 'Familia', accessor: 'family' },
  { Header: 'Aprobado por', accessor: 'approved_user_name' },
  { Header: 'Auditor', accessor: 'auditor' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const generationColumns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 230 },
  { Header: 'ID', accessor: 'id', width: 100 },
  { Header: 'Proveedores', accessor: 'providers', Cell: ({ value }) => value ? (value.length > 100 ? `${value.substring(0, 100)}...` : value) : '' },
  { Header: 'Marcas', accessor: 'marks', Cell: ({ value }) => value ? (value.length > 40 ? `${value.substring(0, 40)}...` : value) : '' },
  { Header: 'Fec. Creación', accessor: 'created_at' },
  { Header: 'Fec. Act.', accessor: 'updated_at' },
  { Header: 'Fec. Aprobación', accessor: 'approved_at' },
  { Header: 'Zona', accessor: 'zone' },
  { Header: 'Almacén', accessor: 'WhsName' },
  { Header: 'Aprobado por', accessor: 'approved_by' },
  { Header: 'Auditor', accessor: 'auditor' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function KardexSharedFile(props) {
  const classes = useStyles();

  const { title, entity, type, excelName, permissions } = props;

  const [kardexs, setKardexs] = useState([]);
  const [valueSearch, setValueSearch] = useState({});
  const [openPDF, setOpenPDF] = useState(false);
  const [urlPDF, setURLPDF] = useState('');
  const [processing, setProcessing] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  async function listInventory(search) {
    setDataLoading(true);
    setValueSearch(search);
    let response = await wsFindBy('logi/inventory-index', search);
    setDataLoading(false);
    if (response.success) setKardexs(response.data);
  }

  function getUrlPDF(idItem) {
    setDataLoading(true);
    let urlPdfHR = wsUrl(`${entity}/${idItem}/ver-pdf`);
    setURLPDF(urlPdfHR);
    // console.log(urlPdfHR);
    setOpenPDF(true);
    setDataLoading(false);
  }

  async function restoreError(item) {
    setDataLoading(true);
    setProcessing(true);
    let res = await wsUpdate(`${entity}/${item.id}/remove-error`);
    setProcessing(false);
    setDataLoading(false);
    if (res.success) {
      listInventory(valueSearch);
    }
    window.alert(res.message);
  }

  return (
    <>
      <ModalFull
        title="Hoja reparto"
        open={openPDF}
        setOpen={() => {
          setOpenPDF(!openPDF);
        }}
        iframe
      >
        <iframe src={openPDF ? urlPDF : undefined} width="100%" height="100%">
          No se pudo cargar el contenido.
          
        </iframe>
      </ModalFull>
      <Card>
        <CardHeader icon>
          <AllowedGuard
            permission={permissions.store}
            component={
              <CardIcon color={props.themeContext.buttonColor}>
                <Assignment style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <Link to={`nuevo?type=${type}`}>
              <CardIcon pointer="true" color="success">
                <Add style={{ color: 'white' }} />
              </CardIcon>
            </Link>
          </AllowedGuard>

          <h4 className={classes.cardIconTitle}>Listado de {title} {dataLoading && <LoadingSpinner />}</h4>
        </CardHeader>
        <CardBody>
          <FilterCustom
            dateRange
            getFilter={listInventory}
            diffRange={4}
            state
            nameState="state"
            // zone
            warehouse="N"
            optionValues={['','BORRADOR', 'PENDIENTE_FIRMA', 'GENERADO', 'PENDIENTE_APROBACION', 'APROBADO']}
            nameOptions={['Todos','Borrador', 'Pendiente de firma', 'Generado', 'Pendiente de aprobación', ' Aprobado',]}
            defaultValue=""
          />

          <ReactTable
            excelName={excelName}
            formatDate="DD-MM-YYYY"
            defaultWidth={1500}
            columns={type === 'GN' ? generationColumns : columns}
            data={kardexs.map((item, i) => {
              let state;
              let stateColor = '';
              let hasError = false;
              switch (item.state) {
                case 'BORRADOR':
                  stateColor = 'warning';
                  state = 'Borrador';
                  break;
                case 'PENDIENTE_FIRMA':
                  stateColor = 'primary';
                  state = 'Pendiente de firma';
                  break;
                case 'GENERADO':
                  stateColor = 'info';
                  state = 'Generado';
                  break;
                case 'PENDIENTE_APROBACION':
                  stateColor = 'warning';
                  state = 'Pendiente de aprobación';
                  break;
                case 'APROBADO':
                  stateColor = 'success';
                  state = 'Aprobado';
                  break;
                case 'ANULADO':
                  stateColor = 'danger';
                  state = 'Anulado';
                  break;
                default:
                  stateColor = 'gray';
                  state = 'Otros';
                  break;
              }
              // if (item.state === 'GENERADO' && item.sapCount >= 3) {
              //   hasError = true;
              // }
              // let guide = null;
              // if (!!item.GuideSerie) {
              //   guide = `${item.GuideSerie}-${item.GuideNumber.padStart(8, '0')}`;
              // }
              return {
                num: (
                  <Box display="flex" alignItems="center">
                    {i + 1}
                    <AllowedGuard permission={permissions.show}>
                      <Button justIcon round simple>
                        <Link to={`${item.id}?type=${type}`}>
                          <Visibility />
                        </Link>
                      </Button>
                    </AllowedGuard>

                    <AllowedGuard permission={permissions.show}>
                      <Button
                        justIcon
                        round
                        simple
                        color="info"
                        onClick={() => getUrlPDF(item.id)}
                        // disabled={item.pdf_firmado === null}
                      >
                        <PictureAsPdf />
                      </Button>
                    </AllowedGuard>
                    <AllowedGuard permission={permissions.destroy}>
                      <ButtonDelete
                        disabled={['APROBADO'].includes(item.state)}
                        entity={entity}
                        id={item.id}
                        reload={() => listInventory(valueSearch)}
                      />
                    </AllowedGuard>

                    {hasError ? (
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <Tooltip title={item.sapError}>
                          <div>
                            <Badge color="danger">Error!</Badge>
                          </div>
                        </Tooltip>
                        <Button
                          size="sm"
                          color="danger"
                          disabled={processing}
                          justIcon
                          simple
                          round
                          onClick={() => restoreError(item)}
                        >
                          <Restore />
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Badge color={stateColor}>{state}</Badge>
                      </div>
                    )}
                  </Box>
                ),
                state: state,
                id: item.id,
                providers: item.is_expiring ? (
                  <span>
                    {item.providers ? item.providers.split(',')[0] : '-'}{' '}
                    <Badge color="rose">Toma de vencimiento</Badge>
                  </span>
                ) : (
                  item.providers
                ),
                marks: item.marks,
                created_at: item.created_at,
                updated_at: item.updated_at,
                approved_at: item.approved_at,
                CardCode: item.CardCode,
                CardName: item.CardName,
                zone: item.zone,
                WhsName: item.WhsName,
                mark: item.mark,
                category: item.category,
                line: item.line,
                family: item.family,
                approved_by: item.approved_by,
                auditor: item.auditor,
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
